
import React from 'react';
import { Shield, Brain, Globe, Lock, Cpu, Zap, Search, Activity, Layers, Code, ShoppingCart, Layout } from 'lucide-react';
import { ServiceItem, ValueItem, NavItem } from './types';

export const COMPANY_NAME = "Sentrix Astra Technologies Ltd";
export const TAGLINE = "Securing Intelligence. Powering the Future.";

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Industries', href: '#industries' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Contact', href: '#contact' }
];

export const CORE_VALUES: ValueItem[] = [
  {
    title: "Security by Design",
    description: "Integrating deep security protocols from the conceptual phase to deployment.",
    icon: <Shield className="w-6 h-6 text-[#00d1ff]" />
  },
  {
    title: "Innovation with Responsibility",
    description: "Pushing boundaries while maintaining ethical and secure standards.",
    icon: <Zap className="w-6 h-6 text-[#7000ff]" />
  },
  {
    title: "Trust & Transparency",
    description: "Open communication and verified security implementations for every client.",
    icon: <Lock className="w-6 h-6 text-[#00d1ff]" />
  },
  {
    title: "Scalable Intelligence",
    description: "Designing solutions that grow and adapt alongside your organizational needs.",
    icon: <Brain className="w-6 h-6 text-[#00d1ff]" />
  },
  {
    title: "Engineering Excellence",
    description: "Rigorous standards and high-performance engineering in every digital asset.",
    icon: <Cpu className="w-6 h-6 text-[#7000ff]" />
  }
];

export const SERVICES: ServiceItem[] = [
  {
    title: "Cybersecurity & AI Security",
    description: "Holistic protection for the modern threat landscape.",
    icon: <Lock className="w-8 h-8" />,
    features: [
      "SOC Build & Optimization",
      "Vulnerability Assessment & Penetration Testing",
      "Security Evaluation",
      "Incident Response Planning",
      "AI Model & Data Security",
      "Security Awareness Training"
    ]
  },
  {
    title: "AI Automation",
    description: "Transforming operations with intelligent, secure workflows.",
    icon: <Brain className="w-8 h-8" />,
    features: [
      "AI Workflow Automation",
      "Secure AI Chatbots",
      "Business Process Automation",
      "Intelligent Analytics Systems"
    ]
  },
  {
    title: "Web & Digital Solutions",
    description: "Crafting future-ready digital platforms and experiences.",
    icon: <Globe className="w-8 h-8" />,
    features: [
      "Corporate & Business Websites",
      "NGO & Foundation Websites",
      "E-commerce Platforms",
      "Secure Portals & Dashboards"
    ]
  }
];
